import React from 'react'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography'
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table'
import Icon from 'material-ui/Icon'
import Badge from 'material-ui/Badge'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import {
  getFormattedNumber,
  getDash
} from '../../../../../common/utils'

const PairResultsViewer = (props) => {
  const { classes, data, translate } = props

  const columns = ['pairname', 'worstvaluedB', 'worstfrequency', 'pairstatus']

  const getState = (state) => {
    if (state === 'MarginalPass') {
      return (
        <Badge badgeContent={"!"} className={classes.passStateBadge}>
          <Icon className={classes.passState}>check_circle</Icon>
        </Badge>
      )
    } else if (state === 'MarginalFail') {
      return (
        <Badge badgeContent={"!"} className={classes.failStateBadge}>
          <Icon className={classes.failState}>cancel</Icon>
        </Badge>
      )
    } else if (state === 'Pass') {
      return (<Icon className={classes.passState}>check_circle</Icon>)
    }
    else if (state === 'Info') {
      return (<Icon className={classes.passState}>info</Icon>)
    }
    else {
      return (<Icon className={classes.failState}>cancel</Icon>)
    }
  }

  return (
    <div className={classes.pairresults} align="center">
      <Typography type={"title"}>{translate('pair_results')}</Typography>
      <Table className={classes.pairResultTable}>
        <TableHead>
          <TableRow>
            {
              columns.map((column, key) => {
                return (
                  <TableCell key={key}>{translate(column)}</TableCell>
                )
              })
            }
          </TableRow>
        </TableHead>
        <TableBody>
          {
            data.map((row, key) => {
              let invalidMargin = row['worstmargin'] === 99999;
              return (
                <TableRow key={key}>
                  <TableCell padding='none'>{row['pairname']}</TableCell>
                  <TableCell numeric={true}>{invalidMargin ? getDash() : getFormattedNumber(row['worstmargin'])}</TableCell>
                  <TableCell numeric={true}>{getFormattedNumber(row['worstfrequency'])}</TableCell>
                  <TableCell>
                    <React.Fragment>
                      {invalidMargin ? getState('Info') : getState(row['pairstatus'])}
                    </React.Fragment>
                  </TableCell>
                </TableRow>
              )
            })
          }
        </TableBody>
      </Table>
    </div>
  )

}

export default withStyles(styles)(PairResultsViewer)
